// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".health_label__sKz\\+P {\r\n    font-weight: 300;\r\n}\r\n\r\n.health_value__aCm1y {\r\n    font-weight: 500;\r\n}", "",{"version":3,"sources":["webpack://./src/pages/health.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".label {\r\n    font-weight: 300;\r\n}\r\n\r\n.value {\r\n    font-weight: 500;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "health_label__sKz+P",
	"value": "health_value__aCm1y"
};
export default ___CSS_LOADER_EXPORT___;
